import { useDispatch, useSelector } from 'react-redux';
import { NAME } from '../store/models/addressBookUsers';

const useAddressBookUsers = () => {
  const { users } = useSelector(state => state[NAME]);
  const isLoading = useSelector(state => state.loading.effects[NAME].load);
  const dispatch = useDispatch();

  return {
    load: dispatch[NAME].load,
    users,
    isLoading,
  };
};

export default useAddressBookUsers;
